var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.629,
    height: 17.619,
    viewBox: "0 0 17.629 17.619",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun_Download_4032792",
    transform: "translate(-2.996 -3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35559",
    "data-name": "Group 35559",
    transform: "translate(2.996 3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_64107",
    "data-name": "Path 64107",
    d: "M11.2,16.42a.979.979,0,0,0,1.39,0L16.5,12.5a.983.983,0,1,0-1.39-1.39l-2.242,2.251V3.979a.979.979,0,0,0-1.958,0v9.387L8.674,11.115a.983.983,0,0,0-1.39,1.39Z",
    transform: "translate(-3.08 -3)",
    fill: "#2580ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64108",
    "data-name": "Path 64108",
    d: "M20.335,17.284a.979.979,0,0,0-1.39,0l-1.664,1.674H6.338L4.674,17.284a.983.983,0,0,0-1.39,1.39l1.958,1.958a.979.979,0,0,0,.695.284H17.683a.979.979,0,0,0,.695-.284l1.958-1.958a.979.979,0,0,0,0-1.39Z",
    transform: "translate(-2.996 -3.296)",
    fill: "#2580ec"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/downloadIcon.fe9d873dd917accf07c53e8d070f1b3a.svg";
export { ForwardRef as ReactComponent };